// Wait for Rebuy to load and cart to be ready
document.addEventListener("rebuy.ready", function (event) {
    console.log("✅ Rebuy cart is ready", event.detail);

    if (!window.rebuyShipsToday) return console.log("PF: Settings not found");

    const rebuyShipsTodayElm = document.querySelector(window.rebuyShipsToday.selector);

    if (!rebuyShipsTodayElm) return console.log("PF: Rebuy element not found");


    const cutoffHour = window.rebuyShipsToday.shipsTodayHour || 11;
    const cutoffMinute = window.rebuyShipsToday.shipsTodayMinute || 0;

    const holidays = [
        "2025-01-01",
        "2025-01-20",
        "2025-02-17",
        "2025-05-26",
        "2025-07-04",
        "2025-09-01",
        "2025-10-13",
        "2025-11-11",
        "2025-11-27",
        "2025-12-25",
    ];

    function updateMessage() {
        const now = new Date();
        const estNow = new Date(
            now.toLocaleString("en-US", { timeZone: "America/New_York" })
        );
        const day = estNow.getDay();
        const dateStr = estNow.toISOString().split("T")[0];
        const isHoliday = holidays.includes(dateStr);

        const cutoffTime = new Date(estNow);
        cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);

        let message = "";

        if (isHoliday) {
            message = window.rebuyShipsToday.businessDay;
        } else if (day >= 1 && day <= 4) {
            if (estNow < cutoffTime) {
                message = window.rebuyShipsToday.today;
            } else {
                message = window.rebuyShipsToday.tomorrow;
            }
        } else if (day === 5) {
            if (estNow < cutoffTime) {
                message = window.rebuyShipsToday.today;
            } else {
                message = window.rebuyShipsToday.monday;
            }
        } else {
            message = window.rebuyShipsToday.monday;
        }

        rebuyShipsTodayElm.innerHTML = `
            ${window.rebuyShipsToday.icon}
            <span class="rebuy-ships-today-msg">
                ${message}
            </span>
        `;
    }

    updateMessage();
});
